// extracted by mini-css-extract-plugin
export default {"list":"user__list","save":"user__save","spinner":"user__spinner","save_form":"user__save_form","control":"user__control","extraSpacing":"user__extraSpacing"};